import {createUseStyles} from "react-jss";
import {breakpoints} from "constants/breakpoints";

const styles = createUseStyles({
  loyaltyBadges: {}
});

export default styles;
